import React, { useState } from 'react';
import { Search, Package, MapPin, Clock, CheckCircle, Loader } from 'lucide-react';
import { mockPackages } from '../utils/mockData';

export const TrackingSection = () => {
  const [trackingNumber, setTrackingNumber] = useState('');
  const [searchResult, setSearchResult] = useState(null);
  const [isSearching, setIsSearching] = useState(false);
  const [error, setError] = useState('');

  const handleSearch = (e) => {
    e.preventDefault();
    setError('');
    setSearchResult(null);
    
    if (!trackingNumber.trim()) {
      setError('Veuillez entrer un numéro de suivi');
      return;
    }

    setIsSearching(true);
    
    // Simulate API call
    setTimeout(() => {
      const foundPackage = mockPackages.find(
        pkg => pkg.trackingNumber.toLowerCase() === trackingNumber.trim().toLowerCase()
      );
      
      if (foundPackage) {
        setSearchResult(foundPackage);
      } else {
        setError('Numéro de suivi introuvable. Essayez RC2024001CI, RC2024002FR ou RC2024003CI');
      }
      setIsSearching(false);
    }, 800);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'Livré':
        return 'bg-green-100 text-green-800 border-green-300';
      case 'En transit':
        return 'bg-blue-100 text-blue-800 border-blue-300';
      case 'En attente':
        return 'bg-yellow-100 text-yellow-800 border-yellow-300';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-300';
    }
  };

  return (
    <section id="tracking" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#204FA7] mb-4">
            Suivre mon colis
          </h2>
          <p className="text-lg text-gray-600">
            Cliquez sur le bouton suivre mon colis pour localiser votre colis en temps réel
          </p>
        </div>

        {/* Search Form */}
        <div className="max-w-2xl mx-auto mb-12">
          <form onSubmit={handleSearch} className="relative">
            <div className="relative">
             {/*  <input
                type="text"
                value={trackingNumber}
                onChange={(e) => setTrackingNumber(e.target.value)}
                placeholder="Entrez votre numéro de suivi (ex: RC2024001)"
                className="w-full px-6 py-4 pr-40 text-lg border-2 border-gray-300 rounded-xl focus:outline-none focus:border-[#204FA7] transition-colors"
              /> */}
              {/* <button
                type="submit"
                disabled={isSearching}
                className="absolute right-2 top-1/2 -translate-y-1/2 bg-[#204FA7] text-white px-6 py-3 rounded-lg hover:bg-[#1a3f87] transition-colors font-medium flex items-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSearching ? (
                  <>
                    <Loader className="animate-spin" size={20} />
                    <span>Recherche...</span>
                  </>
                ) : (
                  <>
                    <Search size={20} />
                    <span>Suivre</span>
                  </>
                )}
              </button> */}
            </div>
          </form>
          
          {error && (
            <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-lg text-red-700">
              {error}
            </div>
          )}
        </div>

        {/* Search Result */}
        {searchResult && (
          <div className="max-w-4xl mx-auto animate-fadeIn">
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden border-2 border-[#204FA7]/10">
              {/* Header */}
              <div className="bg-gradient-to-r from-[#204FA7] to-[#1CA1CC] p-6 text-white">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm opacity-90">Numéro de suivi</p>
                    <p className="text-2xl font-bold">{searchResult.trackingNumber}</p>
                  </div>
                  <div className={`px-4 py-2 rounded-lg border-2 ${getStatusColor(searchResult.status)} bg-white`}>
                    <span className="font-semibold">{searchResult.status}</span>
                  </div>
                </div>
              </div>

              {/* Details */}
              <div className="p-6 space-y-6">
                {/* Route Info */}
                <div className="grid md:grid-cols-3 gap-4">
                  <div className="flex items-start space-x-3">
                    <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <MapPin className="text-[#204FA7]" size={20} />
                    </div>
                    <div>
                      <p className="text-sm text-gray-600">Origine</p>
                      <p className="font-semibold text-gray-900">{searchResult.origin}</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-3">
                    <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <MapPin className="text-[#F3A530]" size={20} />
                    </div>
                    <div>
                      <p className="text-sm text-gray-600">Destination</p>
                      <p className="font-semibold text-gray-900">{searchResult.destination}</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-3">
                    <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <Clock className="text-green-600" size={20} />
                    </div>
                    <div>
                      <p className="text-sm text-gray-600">Livraison prévue</p>
                      <p className="font-semibold text-gray-900">
                        {new Date(searchResult.estimatedDelivery).toLocaleDateString('fr-FR', {
                          day: 'numeric',
                          month: 'long',
                          year: 'numeric'
                        })}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Current Location */}
                <div className="bg-blue-50 p-4 rounded-xl">
                  <div className="flex items-center space-x-3">
                    <Package className="text-[#204FA7]" size={24} />
                    <div>
                      <p className="text-sm text-gray-600">Position actuelle</p>
                      <p className="font-semibold text-[#204FA7]">{searchResult.currentLocation}</p>
                    </div>
                  </div>
                </div>

                {/* History Timeline */}
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-4">Historique du colis</h3>
                  <div className="space-y-4">
                    {searchResult.history.map((event, index) => (
                      <div key={index} className="flex items-start space-x-4">
                        <div className="flex-shrink-0 w-10 h-10 bg-[#204FA7] rounded-full flex items-center justify-center">
                          <CheckCircle className="text-white" size={20} />
                        </div>
                        <div className="flex-1 pb-4 border-b border-gray-200 last:border-0">
                          <div className="flex items-center justify-between mb-1">
                            <p className="font-semibold text-gray-900">{event.event}</p>
                            <p className="text-sm text-gray-500">{event.date}</p>
                          </div>
                          <p className="text-sm text-gray-600">{event.location}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Help Section */}
            <div className="mt-6 text-center">
              <p className="text-gray-600 mb-3">Besoin d'aide avec votre colis ?</p>
              <a 
                href="https://wa.me/33695701735?text=Bonjour,%20j'ai%20une%20question%20concernant%20mon%20colis"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-2 text-[#204FA7] hover:text-[#1a3f87] font-medium"
              >
                <span>Contactez-nous sur WhatsApp</span>
              </a>
            </div>
          </div>
        )}

        {/* Demo Info */}
        {!searchResult && !error && (
          <div className="max-w-2xl mx-auto text-center">
            <div className="bg-blue-50 border border-blue-200 rounded-xl p-6">
              <p className="text-sm text-gray-700">
                <span className="font-semibold text-[#204FA7]">Essayez avec un numéro de démonstration :</span><br />
                RC2024001CI • RC2024002FR • RC2024003CI
              </p>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};
